import React, { useCallback, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

import Icon from '@components/dataDisplay/Icons/Icon';
import { dropdownDirMap } from '@components/wrapper/DropdownWrapper';
import { useRecoilState, useRecoilValue } from 'recoil';
import { fuego, useCollection } from '@nandorojo/swr-firestore';
import { Inotification } from '@typings/notification/notification.interface';
import { CollectionPath } from '@typings/collections.enum';
import NotiBadge from './NotiBadge';
import { notificationOpenState } from '@atom/setting/jukebox';
import { notificationSettingsState } from '@atom/setting/notification';

const ButtonWrap = styled.div`
  border-radius: var(--buttonBorderRadius);
  transition: background-color 0.3s;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: relative;

  &:hover {
    background-color: var(--inkColor);
    cursor: var(--hoverCursorURL), pointer;
  }
`;

const Container = styled.div`
  position: relative;
`;

type Props = {
  dropdownDir?: keyof typeof dropdownDirMap | undefined;
  color?: string;
};

function NotificationBtn({ dropdownDir, color }: Props) {
  const [open, setOpen] = useRecoilState(notificationOpenState);
  const currentUserId = fuego.auth().currentUser?.uid;
  const collectionPath = `${CollectionPath.USERS}/${currentUserId}/${CollectionPath.NOTIFICATIONS}`;

  const notificationSettings = useRecoilValue(notificationSettingsState);

  // 안읽은 메시지 count --------------------------------------
  const [unreadNumber, setUnreadNumber] = useState<number>(0);
  const prevUnreadCountRef = useRef<number>(0);
  const isInitialLoadRef = useRef<boolean>(true);

  const { data: noReadList } = useCollection<Inotification>(collectionPath, {
    listen: true,
    where: ['is_seen', '==', false],
  });

  useEffect(() => {
    if (noReadList) {
      const newUnreadCount = noReadList.length;
      setUnreadNumber(newUnreadCount);
      prevUnreadCountRef.current = newUnreadCount;
      isInitialLoadRef.current = false;
    }
  }, [noReadList]);
  // 안읽은 메시지 count --------------------------------------

  const handleNotiOpen = useCallback(() => {
    setOpen((prev) => !prev);
  }, []);

  return (
    <>
      <Container>
        <ButtonWrap onClick={handleNotiOpen}>
          <Icon name="Bell18" color={color} />
          <NotiBadge unreadNumber={unreadNumber} />
        </ButtonWrap>
      </Container>
    </>
  );
}

export default NotificationBtn;
